import { render, staticRenderFns } from "./ButtonCreatePurchaseBuyer.vue?vue&type=template&id=218dca9d&"
import script from "./ButtonCreatePurchaseBuyer.vue?vue&type=script&lang=ts&"
export * from "./ButtonCreatePurchaseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports